<template>
  <div class="md-layout">
    <div class="header">
      <div class="headerCon">
        <div class="headerLeft">
          <div class="logs">
            <img :src="userData.avatar?userData.avatar:require('@/assets/img/apple-icon.png')" width="70px" class="logImg" alt="" />
          
          </div>
          <div class="logsRight">
            <p>{{userData.nickName?userData.nickName:'陌生用户'}}</p>
            <div class="pubLogIcon">
              <span style="display: inline-block; transform: translateY(1px)">学习力</span> 
               <img src="@/assets/mylearing/opeico.png" alt="" class="openIcon" /> 

              <div style="display: inline-block">
                <v-progress-linear
                  v-model="power"
                  style="
                    width: 100px;
                    display: inline-block;
                    margin-left: 50px;
                    positon: absolute;
                    top: 5px;
                  "
                  class="line"
                  color="amber"
                  height="5"
                ></v-progress-linear>
                <span class="lefts">学富五车</span>
                <span class="rights">4006000</span>
              </div>
            </div>

            <div class="pubLogIcon" style="margin-top: 1px">
              <span style="display: inline-block; transform: translateY(1px)">经验</span>
              <div style="display: inline-block">
                <v-progress-linear
                  v-model="power"
                  style="
                    width: 100px;
                    display: inline-block;
                    margin-left: 62px;
                    positon: absolute;
                    top: 5px;
                  "
                  class="line"
                  color="amber"
                  height="5"
                ></v-progress-linear>
                <span class="lefts">Lv5</span>
                <span class="rights">1256000</span>
              </div>
            </div>
          </div>
        </div>
        <div class="headerRight">
          <div class="logsRightTime">
            <p>今日已学 <b style="font-weight:bold;">20</b> 分钟</p>
            <p>坚持学习 <b style="font-weight:bold;">2</b> 天</p>
          </div>
        </div>
      </div>
    </div>
    <div class="wrap">
      <v-card style="padding: 0 20px">
        <!-- <v-card> -->
          <v-tabs v-model="tab" color="green" class="custom-tab" :items="false" align-tabs="center">
            <v-tab :value="item.value" v-for="(item, index) in tabs" :key="index">{{
              item.label
            }}</v-tab>
          </v-tabs>
        <!-- </v-card> -->

        <v-tabs-items v-model="tab">
          <v-tab-item key="tab-base">
            <learningCourses></learningCourses>
          </v-tab-item>
          <v-tab-item key="tab-ext">
            <favorites></favorites>
          </v-tab-item>
          <v-tab-item key="tab-act">
            <historyLearning></historyLearning>
          </v-tab-item>
          <v-tab-item key="tab-int">
           <achieve></achieve>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </div>
  </div>
</template>
<script>
import learningCourses from './components/learningCourses.vue';
import favorites from './components/favorites.vue';
import historyLearning from './components/historyLearning.vue';
import achieve from './components/achieve.vue';

export default {
  components: {
    learningCourses,
    favorites,
    historyLearning,
    achieve
  },
  data() {
    return {
      power: 40,
      tabs: [
        {
          label: '学习课程',
          value: '0',
        },
        {
          label: '收藏夹',
          value: '1',
        },
        {
          label: '历史学习数据',
          value: '2',
        },
        {
          label: '达成成就',
          value: '3',
        },
      ],
      tab: 0,
      userData:{},
    };
  },
  created() {
    this.getUser();
  },
  methods: {
    //设置用户头像和名称
    getUser(){
      if(window.localStorage.getItem('USER_INFO')){
            let userData =  JSON.parse(window.localStorage.getItem('USER_INFO'))
            if(userData&&userData.user){
               this.userData = userData.user
            }
      }

    },
  },
};
</script>

<style scoped>
.header {
  width: 100%;
  background: #4caf50 !important;
  height: 90px;
  overflow: hidden;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
  /* margin-bottom: 0px; */
  margin: 0 0px 0px 10px;
}
/* >>> .md-button-content{
  color: #000;
} */
.wrap {
  overflow: hidden;
  padding: 10px;
  color: #000;
  width: 80%;
  /* border: 1px solid red; */
  margin: 10px auto;
  height: auto;
  /* padding: 10px; */
}

>>> .custom-tab .v-tabs-slider {
  display: none; /* 移除默认的下划线 */
}

.headerCon {
  width: 80%;
  margin: 0 auto;
  height: 100%;
  /* background: red; */
}
.headerLeft {
  float: left;
  width: 50%;
  height: 100%;
}
.headerRight {
  float: right;
  width: 50%;
  height: 100%;
}
.logs {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  position: relative;
  top: 10px;
  float: left;
  cursor: pointer;
  box-shadow: 0 0 8px 0 rgb(177, 177, 177);
}
.logImg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  overflow: hidden;
}
.logsRight {
  height: 80px;
  width: 220px;
  position: relative;
  top: 10px;
  float: left;
  margin-left: 18px;
  overflow: hidden;
  color: #fff;
}

.logsRightTime {
  height: 80px;
  width: 220px;
  position: relative;
  top: 10px;
  float: right;
  margin-left: 18px;
  overflow: hidden;
  color: #fff;
}
.logsRightTime div {
  margin-bottom: 4px;
  color: #fff;
}

.pubLogIcon .openIcon {
    position: absolute;
    bottom: -5px;
    left: -110px;
    right: 0;
    margin: auto;
    width: 22px;
    height: 22px;
}

.pubLogIcon {
  font-size: 13px;
  position: relative;
}

.logsRight p {
  margin-bottom: 4px;
}

.lefts {
  position: absolute;
  bottom: 5px;
  font-size: 9px;
  left: 88px;
  color: #fff;
}
.rights {
  position: absolute;
  bottom: 5px;
  right: 33px;
  font-size: 9px;
  color: #fff;
}
</style>
